(function () {
  'use strict';
  if (window.YK_LOGIN_GATE) return;
  var DISMISSED = 'ykotp:arrival-dismissed';
  var pending = false;
  function verified() { return !!(window.YK_OTP && window.YK_OTP.isVerified()); }
  function otpReady(fn) {
    var n = 0;
    var t = setInterval(function () {
      if (window.YK_OTP) { clearInterval(t); fn(); }
      else if (++n > 80) clearInterval(t);
    }, 100);
  }
  function login(continueAction) {
    if (verified()) { (window.YK_CART_SESSION ? window.YK_CART_SESSION.ready() : Promise.resolve()).then(continueAction); return; }
    if (pending) return;
    pending = true;
    otpReady(function () {
      window.YK_OTP.open({ onVerified: function () {
        pending = false;
        window.YK_OTP.close();
        (window.YK_CART_SESSION ? window.YK_CART_SESSION.ready() : Promise.resolve()).then(continueAction);
      } });
      var ov = document.querySelector('.ykotp-ov');
      if (!ov) { pending = false; return; }
      var watch = new MutationObserver(function () {
        if (!ov.classList.contains('on')) { pending = false; watch.disconnect(); }
      });
      watch.observe(ov, { attributes: true, attributeFilter: ['class'] });
    });
  }
  function buyNow(button) {
    var form = button.closest('form');
    if (!form) return;
    if (!form.reportValidity()) return;
    var data = new FormData(form);
    if (!data.get('id')) return;
    button.disabled = true;
    fetch(window.routes && window.routes.cart_add_url || '/cart/add.js', {
      method: 'POST', body: data, headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('Could not add this product');
      window.location.assign('/checkout');
    }).catch(function () {
      button.disabled = false;
      window.alert('Unable to start checkout. Please try again.');
    });
  }
  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest(
      '.yk-heart, .yk-pdp-wish, .yk-wish, [data-yk-buy-now], .yk-address-trigger, .pp__atc, .product-form__submit, .quick-add__submit, [data-yks-atc], [data-yks-buy], button[name="add"], .quick-order-list__submit'
    );
    if (!button || button.disabled) return;
    if (button.matches('[data-yk-buy-now]')) {
      e.preventDefault(); e.stopImmediatePropagation();
      login(function () { buyNow(button); });
      return;
    }
    if (verified() && (!window.YK_CART_SESSION || window.YK_CART_SESSION.canUse())) return;
    e.preventDefault(); e.stopImmediatePropagation();
    login(function () { if (button.isConnected) button.click(); });
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (verified() && (!window.YK_CART_SESSION || window.YK_CART_SESSION.canUse())) return;
    var action = form.getAttribute('action') || '';
    if (!(/\/cart\/add(?:\.js)?(?:\?|$)/.test(action) || form.querySelector('[name="checkout"]'))) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var submitter = e.submitter;
    login(function () {
      if (form.isConnected) form.requestSubmit(submitter && submitter.isConnected ? submitter : undefined);
    });
  }, true);
  window.YK_LOGIN_GATE = { isVerified: verified };
  function arrival() {
    if (verified()) return;
    if (/\/(?:cart|account|checkouts?|challenge|tools|apps)(?:\/|$)/.test(location.pathname)) return;
    if (/\/pages\/(?:my-account|sign-in|create-account|phone-login)/.test(location.pathname)) return;
    try { if (sessionStorage.getItem(DISMISSED)) return; } catch (e) {}
    setTimeout(function () {
      if (verified() || pending) return;
      otpReady(function () {
        if (verified() || pending) return;
        window.YK_OTP.open();
        var ov = document.querySelector('.ykotp-ov');
        if (!ov) return;
        var watch = new MutationObserver(function () {
          if (!ov.classList.contains('on')) {
            watch.disconnect();
            if (!verified()) try { sessionStorage.setItem(DISMISSED, '1'); } catch (e) {}
          }
        });
        watch.observe(ov, { attributes: true, attributeFilter: ['class'] });
      });
    }, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrival);
  else arrival();
})();